import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from 'ngx-clipboard';

import { SharedModule } from '@shared';

import { AdvancedLicenseFilterComponent } from './components/advanced-license-filter/advanced-license-filter.component';
import { UserAccountPreviewComponent } from './components/user-account-preview/user-account-preview.component';
import { UserBlockedComponent } from './components/user-blocked/user-blocked.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserMfaComponent } from './components/user-mfa/user-mfa.component';
import { UserPageComponent } from './containers/user-page/user-page.component';
import { UserRoleSearchComponent } from './components/user-role-search/user-role-search.component';
import { UserRolesComponent } from './components/user-roles/user-roles.component';
import { USER_ROUTES } from './user.routes';
import { StoreModule } from '@ngrx/store';
import * as fromPermissions from './state/permissions/permissions.reducer';
import * as fromUserRoles from './state/roles/roles.reducer';
import * as fromUserLicenses from './state/user-licenses/user-licenses.reducer';
import * as fromUsers from './state/users/users.reducer';
import * as fromUser from './state/user/user.reducer';
import { EffectsModule } from '@ngrx/effects';
import { PermissionsEffects } from './state/permissions/permissions.effects';
import { RolesEffects } from './state/roles/roles.effects';
import { AuSharedModule } from '../shared/au-shared.module';
import { UserLicensesEffects } from './state/user-licenses/user-licenses.effects';
import { UsersEffects } from './state/users/users.effects';
import { UserEffects } from './state/user/user.effects';
import { UserSearchPageComponent } from './containers/user-search-page/user-search-page.component';
import { UserUIPreferencesComponent } from './components/user-ui-preferences/user-ui-preferences.component';
import { AccountUserAdvancedFilterComponent } from './components/account-user-advanced-filter/account-user-advanced-filter.component';
import { UserBulkEditComponent } from './components/user-bulk-edit/user-bulk-edit.component';
import { ConfirmBulkEditModalComponent } from './components/confirm-bulk-edit-modal/confirm-bulk-edit-modal.component';
import { InvitationLinkComponent } from './components/invitation-link/invitation-link.component';

import { InvitationLinkModalDirective } from './directives/invitation-link-modal.directive';

import { InvitationLinkService } from './services/invitation-link.service';

const COMPONENTS = [
  AdvancedLicenseFilterComponent,
  UserAccountPreviewComponent,
  UserInfoComponent,
  UserUIPreferencesComponent,
  UserListComponent,
  UserBulkEditComponent,
  UserPageComponent,
  UserSearchPageComponent,
  UserRoleSearchComponent,
  AccountUserAdvancedFilterComponent,
  UserBlockedComponent,
  UserMfaComponent,
  UserRolesComponent,
  ConfirmBulkEditModalComponent,
  InvitationLinkComponent,
];

const DIRECTIVES = [InvitationLinkModalDirective];

@NgModule({
  declarations: [...COMPONENTS, ...DIRECTIVES],
  providers: [InvitationLinkService],
  imports: [
    CommonModule,
    NgbModule,
    ClipboardModule,
    FormsModule,
    SharedModule,
    AuSharedModule,
    RouterModule.forChild(USER_ROUTES),
    EffectsModule.forFeature([PermissionsEffects]),
    StoreModule.forFeature(
      fromPermissions.PERMISSIONS_FEATURE_KEY,
      fromPermissions.reducer,
      {
        initialState: fromPermissions.initialState,
      },
    ),
    EffectsModule.forFeature([RolesEffects]),
    StoreModule.forFeature(
      fromUserRoles.USER_ROLES_FEATURE_KEY,
      fromUserRoles.reducer,
      {
        initialState: fromUserRoles.initialState,
      },
    ),
    EffectsModule.forFeature([UsersEffects]),
    StoreModule.forFeature(fromUsers.USERS_FEATURE_KEY, fromUsers.reducer, {
      initialState: fromUsers.initialState,
    }),
    EffectsModule.forFeature([UserLicensesEffects]),
    StoreModule.forFeature(
      fromUserLicenses.USER_LICENSES_FEATURE_KEY,
      fromUserLicenses.userLicensesreducer,
      {
        initialState: fromUserLicenses.initialState,
      },
    ),
    EffectsModule.forFeature([UserEffects]),
    StoreModule.forFeature(fromUser.USER_FEATURE_KEY, fromUser.userReducer, {
      initialState: fromUser.initialState,
    }),
  ],
})
export class UserModule {}
